import React, { Component } from 'react';
import {Elements, StripeProvider} from 'react-stripe-elements';
import CreditCardForm from './CreditCardForm';
import {STRIPE_API_KEY} from "../Const";

export class PaymentByCreditCard extends Component {
    render() {
        return(
            <StripeProvider apiKey={STRIPE_API_KEY}>
                <div>
                    <h1>Add more minutes to your simulation</h1>
                    <Elements>
                        <CreditCardForm
                            {...this.props}
                        />
                    </Elements>
                </div>
            </StripeProvider>
        )
    }
}

export default PaymentByCreditCard;
